<template>
  <div>
    <v-dialog max-width="500px"
              scrollable
              v-model="showDialog">
      <component @close="closeModal()"
                 :is="selectedComponent"
                 :selectedChannel="selectedChannel"
                 v-if="selectedChannel">
      </component>
    </v-dialog>

    <span>
      <v-tooltip top
                 v-for="item in autoStarts"
                 :key="item.id">
        <template v-slot:activator="{ on }">
          <v-btn @click="openDialog(item)"
                 icon
                 v-on="on">
            <v-icon :color="item.status === 'online' ? 'kbGreen' : 'kbGrey'">
              mdi-{{item.channel === 'smooch_wp' ? 'whatsapp' : item.channel.toLowerCase()}}
            </v-icon>
          </v-btn>
        </template>

        <span>{{item.channel === 'smooch_wp' ? 'Whatsapp' : 'Hibot'}}</span>
      </v-tooltip>
    </span>
  </div>
</template>

<script>
import { EventBus } from '@/eventBus.js'
import { mapState } from 'vuex'
import Sunshine from '@/pages/App/Conversations/Sunshine.vue'
import Hibot from '@/pages/App/Conversations/Hibot.vue'
export default {
  components: {
    Hibot, Sunshine
  },
  computed: {
    ...mapState({
      autoStarts: state => state.conversations.autoStarts,
      initConversation: state => state.conversations.initConversation
    })
  },
  created () {
    EventBus.$on('conversationsOpenAutoStarts', type => {
      const channel = this.autoStarts.find(autoStart => autoStart.channel === type)
      if (channel) this.openDialog(channel)
    })
  },
  data: () => ({
    selectedComponent: null,
    selectedChannel: '',
    showDialog: false
  }),
  methods: {
    closeModal () {
      this.selectedChannel = ''
      this.showDialog = false
    },
    openDialog (channel) {
      this.selectedChannel = channel
      this.selectedComponent = this.selectedChannel.channel === 'whatsApp' ? 'Hibot' : 'Sunshine'
      this.showDialog = true
    }
  },
  watch: {
    autoStarts (value) {
      if (!this.initConversation) return
      const channel = value.find(item => item.id === this.initConversation.id)

      if (!channel) return this.$store.commit('SET_INIT_CONVERSATION', null)

      this.selectedChannel = channel
      this.openDialog(channel)
    }
  }
}
</script>
